import { useEffect } from "react";
import Menu from "../Menubar/Menu";
import NotizenLaden from "./NotizenLaden";
import { Categories } from "../MainMenu/MenüSicht";

var MonitorApi = require('monitor-api');


export function Notizen({ myApiClient, setSection }) {

    var noteInstance = new MonitorApi.NotizApi(myApiClient);
    
    useEffect(() => {
        setSection('Notizen');
      }, [setSection]);

    return (
        <div className="next-to-menu">
            <Menu/>
            <Categories>
                <h1>Notizen</h1>

                <NotizenLaden noteInstance={noteInstance}/>
                
            </Categories>
        </div>
    )
}